module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "container-fluid page-section clearfix",
    attrs: {
      "id": "section-about"
    }
  }, [_c('div', {
    staticClass: "page-section",
    attrs: {
      "id": "section-portfolio"
    }
  }, [_c('span', {}, [_vm._v("Portfolio Item")]), _vm._v(" "), _c('h1', {
    staticClass: "bottommargin"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "postcontent bothsidebar nobottommargin"
  }, [_c('div', {
    staticClass: "col_full portfolio-single-content"
  }, [_c('p', [_vm._v("Thank you for your interest. More about this project will be coming soon.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b5326b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portfolio-item.vue
// module id = 109
// module chunks = 1